

export function getEnabledFilters(filterables, filterId) 
{
    let enabledFilters = [];
    //console.log({filterables, filterId});
    Object.keys(filterables[filterId]).forEach(k => {if (filterables[filterId][k]) enabledFilters.push(k)});
    return { filterables: Object.keys(filterables[filterId]), enabledFilters };
}

export function makeDictionary(arr)
{
  let result = {};
  arr.forEach(el => result[el.id] = el);
  return result;
}


// WEBPACK FOOTER //
// ./src/features/common/util.js